import React from "react";
import authService from "../../services/authService";
import { clearImpersonationSession } from "../../supportMode/supportModeSession";
import { clearActiveMasterAccountId } from "../activeMasterAccount";
import { useTenant } from "../TenantContext";

export default function BootstrapErrorPage() {
  const { error, refresh } = useTenant();

  const handleSignOut = async () => {
    clearActiveMasterAccountId();
    clearImpersonationSession();
    await authService.logout();
  };

  return (
    <div style={{ padding: 32, maxWidth: 560 }} data-testid="bootstrap-error">
      <h1 style={{ fontSize: 22, marginBottom: 12 }}>
        Unable to load tenant
      </h1>
      <p style={{ marginBottom: 12 }}>
        {error?.message ||
          "Master Account bootstrap failed. The authenticated application cannot start."}
      </p>
      {error?.code ? (
        <p style={{ color: "#666", fontSize: 13 }}>Code: {error.code}</p>
      ) : null}
      <div style={{ marginTop: 24, display: "flex", gap: 12 }}>
        <button type="button" onClick={() => refresh()}>
          Retry
        </button>
        <button type="button" onClick={handleSignOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}
